module.exports = __webpack_public_path__ + "static/media/arhiteh_header.c4444ffb.png";